<template>
  <InteractionStep :disabled-next="false"
                   :pending-next="pendingSave"
                   @next="onSave">

    <template v-slot:content>
      <div class="step-information">
        <div class="step-information__section">
          <div class="step-information__row">
            <div class="step-information__col-6">
              <div class="">
                <span class="step-information__label">
                  {{ $tInteraction('Your name') }}
                  <span class="step-information__sub">
                    ({{ $tInteraction('in Latin') }})
                  </span>
                </span>
                <BaseInput :value="inputs.name.value"
                           :error="inputs.name.error"
                           :regexp="/[^A-Za-z]+/g"
                           @input="setInputValue(['name', $event])"
                           @change="setInputValue(['name', $event])"/>
              </div>
            </div>
            <div class="step-information__col-6">
              <div class="">
                <span class="step-information__label">
                  {{ $tInteraction('Surname') }}
                  <span class="step-information__sub">
                    ({{ $tInteraction('in Latin') }})
                  </span>
                </span>
                <BaseInput :value="inputs.surname.value"
                           :error="inputs.surname.error"
                           :regexp="/[^A-Za-z]+/g"
                           @input="setInputValue(['surname', $event])"
                           @change="setInputValue(['surname', $event])"/>
              </div>
            </div>
          </div>
          <div class="step-information__row">
            <ButtonCheckList :value="inputs.gender.value"
                             :error="inputs.gender.error"
                             :options="genders"
                             type="radio"
                             compareType="id"
                             text-key="name"
                             @input="setInputValue(['gender', $event])"
                             class="step-information__check-list"
            />
          </div>

        </div>
        <div class="step-information__section">
          <span class="step-information__label">
            {{ $tInteraction('Date of Birth') }}
          </span>
          <BirthdaySelect :value="inputs.birthday.value"
                          :error="inputs.birthday.error"
                          @input="setInputValue(['birthday', $event])"
                          class="step-information__birthday"/>
        </div>
        <div class="step-information__section">
          <div class="step-information__row">
            <div class="step-information__col-12">
              <span class="step-information__label">
                {{ $tInteraction('Citizenship') }}
              </span>
              <ButtonCheckList :value="citizenshipValueComputed"
                               :error="inputs.citizenship.error"
                               :options="citizenshipComputed"
                               type="radio"
                               text-key="name"
                               compare-type="id"
                               @input="citizenshipInput"
                               class="step-information__check-list"
              />
            </div>
          </div>
          <div class="step-information__row" v-if="citizenshipValue && citizenshipValue.id === 'other'">
            <SCountry
                :label="$tInteraction('Specify country')"
                :value="inputs.citizenship.value"
                @input="setInputValue(['citizenship', $event])"
                class="step-information__select"
            />
          </div>


        </div>
        <div class="step-information__section">
          <div class="step-information__row">
            <div class="step-information__col-6">
              <div class="">
                <span class="step-information__label">
                  {{ $tInteraction('Series and number of passport') }}
                </span>
                <div class="step-information__passport">
                  <BaseInput :value="inputs.international_passport_series.value"
                             :error="inputs.international_passport_series.error"
                             mask="XX"
                             @input="setInputValue(['international_passport_series', $event])"
                             class="step-information__passport-series"/>
                  <BaseInput :value="inputs.international_passport_number.value"
                             :error="inputs.international_passport_number.error"
                             mask="#######"
                             @input="setInputValue(['international_passport_number', $event])"/>
                </div>
              </div>
            </div>
          </div>
          <div class="step-information__row">
            <div class="step-information__col-6">
              <DatePiker :label="$tInteraction('Date of issue of the passport')"
                         :value="inputs.international_passport_creation_date.value"
                         :error="inputs.international_passport_creation_date.error"
                         @input="setInputValue(['international_passport_creation_date', $event])"
                         class="_green"/>
            </div>
            <div class="step-information__col-6">
              <DatePiker :label="$tInteraction('Date of expiry of the passport')"
                         :value="inputs.international_passport_expired_date.value"
                         :error="inputs.international_passport_expired_date.error"
                         @input="setInputValue(['international_passport_expired_date', $event])"
                         class="_green"
              />
            </div>
          </div>
        </div>
      </div>
      <BaseAlert :value="error" class="step-information__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import InteractionStep from '../InteractionStep'
  import ButtonCheckList from '../../ButtonCheckList'
  import BirthdaySelect from '../../BirthdaySelect'
  import DatePiker from '../../DatePiker'
  import SCountry from '../../loadingSelects/SCountry'
  import {http} from '../../../axios'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    name: 'InteractionStepPassport',
    mixins: [interactionStepMixin],
    components: {
      InteractionStep,
      ButtonCheckList,
      BirthdaySelect,
      DatePiker,
      SCountry,
    },
    data() {
      return {
        pendingSave: false,
        error: null,
        citizenshipValue: null
      }
    },
    computed: {
      ...mapState('interaction', {
        'genders'(state) {
          return this.translateList(state.genders)
        },
        'otherCountry'(state) {
          return this.translateList([state.otherCountry])[0]
        },
        'citizenship'(state) {
          return state.stepData.data_lists.citizenship
        },
      }),
      ...mapState('interaction/statement', [
        'inputs',
      ]),
      ...mapGetters('interaction/statement', [
        'formData'
      ]),
      citizenshipValueComputed() {
        return this.citizenshipValue || this.inputs.citizenship.value
      },
      citizenshipComputed() {
        let r = this.citizenship
        if (!r) return []

        return [
          ...r,
          this.otherCountry
        ]
      },
    },
    methods: {
      ...mapMutations('interaction/statement', [
        'setInputValue',
      ]),
      translateList(list) {
        list = JSON.parse(JSON.stringify(list))

        return list.map(item => {
          item.name = this.$tAddResume2(item.name)
          return item
        })
      },
      citizenshipInput(value, other) {
        if (value.id === 'other') {
          this.citizenshipValue = value
          this.setInputValue(['citizenship', null])
        } else if (other) {
          this.setInputValue(['citizenship', value])
        } else {
          this.citizenshipValue = value
          this.setInputValue(['citizenship', value])
        }
      },

      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`, this.formData).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      }
    },
    created() {
      const resumeSection1 = this.$store.state.interaction.resume && this.$store.state.interaction.resume.resume_data[1]

      if (resumeSection1) {
        const gender = resumeSection1.gender
        const value = this.genders[gender - 1]
        this.setInputValue(['gender', value])

        const birthday = resumeSection1.birthday
        this.setInputValue(['birthday', birthday])

        const citizenship = resumeSection1.citizenship
        if(!this.citizenshipComputed.some(c => c.id === citizenship.id)) {
          this.citizenshipValue = this.otherCountry
        }
        this.setInputValue(['citizenship', citizenship || null])
      }

    }
  }
</script>

<style>

</style>
